import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../Icon/index.js';
import s from '../lib/composeLabels.js';
import Unit from '../lib/Unit.js';
import { isEnter } from '../lib/isKey.js';
import unitType from '../lib/types/unit.js';

const {
  arrayOf,
  bool,
  shape,
  string
} = PropTypes;
class UnitList extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onToggleClickHandler", () => {
      this.setState(prevState => ({
        collapsed: !prevState.collapsed
      }));
      const {
        collapsed
      } = this.state;
      if (collapsed && this.unitsContainerEl) {
        const firstUnitLink = this.unitsContainerEl.querySelector("a.tds-content-panel__unit-link");
        if (firstUnitLink) {
          firstUnitLink.focus();
        }
      }
    });
    _defineProperty(this, "setUnitsContainerRef", el => {
      this.unitsContainerEl = el;
    });
    this.state = {
      collapsed: props.initiallyCollapsed
    };
    this.unitsContainerEl = null;
    if (props.collapsible) {
      // Set a safe initial height that allows for the units to be collapsed
      // immediately, for example, by a fast Cypress integration test. Actual
      // height will be calculated one second after the component mounts to
      // allow for the time it takes to render this component in storybook and
      // in consumer apps.
      this.unitsContainerHeight = 800;
    }
  }
  componentDidMount() {
    // Storybook has a FOUC moment when the buttons are larger than normal,
    // which goes away after some time. So, waiting a bit before we calculate
    // the height of the units:
    const {
      collapsible
    } = this.props;
    if (collapsible) {
      setTimeout(() => {
        if (this.unitsContainerEl) {
          this.unitsContainerHeight = this.unitsContainerEl.offsetHeight + 1;
        }
      }, 1500);
    }
  }
  render() {
    const {
      units,
      labels,
      collapsible,
      className,
      parentApiName
    } = this.props;
    const {
      collapsed
    } = this.state;
    const unitLabels = {
      completed: labels.unitCompleted,
      incomplete: labels.unitIncomplete
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: cx(className, "tds-content-brick__unit-meta-container slds-text-body_small", {
        "tds-content-brick__unit-meta-container_static": !collapsible
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "tds-content-brick__unit-container",
      id: parentApiName,
      ref: this.setUnitsContainerRef,
      style: {
        marginTop: collapsed ? `-${this.unitsContainerHeight}px` : "0"
      }
    }, units.map(unit => /*#__PURE__*/React.createElement(Unit, Object.assign({
      key: `unit-${unit.title}`
    }, unit, {
      labels: unitLabels,
      a11yHidden: collapsed
    }))))), collapsible && /*#__PURE__*/React.createElement("div", {
      className: "tds-content-panel__unit slds-grid tds-cursor_pointer",
      tabIndex: "0",
      role: "button",
      "aria-expanded": collapsed ? "false" : "true",
      "aria-controls": parentApiName,
      onClick: this.onToggleClickHandler,
      onKeyPress: e => isEnter(e) && this.onToggleClickHandler(),
      "data-test": "unit-list-toggle"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tds-color_brand tds-text_bold slds-m-vertical_small tds-hover_underlined"
    }, /*#__PURE__*/React.createElement(Icon, {
      assistiveText: {
        label: collapsed ? "show" : "hide"
      },
      category: "utility",
      name: collapsed ? "chevrondown" : "chevronup",
      size: "x-small",
      className: "tds-fill_brand slds-m-right_x-small"
    }), collapsed ? s(labels.showNUnits, {
      n: units.length
    }) : s(labels.hideNUnits, {
      n: units.length
    }))));
  }
}
UnitList.displayName = "UnitList";
UnitList.propTypes = {
  units: arrayOf(shape(unitType)).isRequired,
  labels: shape({
    hideNUnits: string,
    showNUnits: string,
    completed: string,
    incomplete: string
  }),
  initiallyCollapsed: bool,
  collapsible: bool,
  parentApiName: string
};
UnitList.defaultProps = {
  initiallyCollapsed: true,
  collapsible: false,
  labels: {},
  parentApiName: ""
};

export { UnitList as default };
